import React, { useState, useEffect } from "react";
import { Phone, Printer } from "@icons";
import { useTranslation } from "react-i18next";
import "./HubungiKami.scss";
import { ContactAPI } from "@api";

const HubungiKami = () => {
  const { t } = useTranslation();
  const [contactUs, setContactUs] = useState(null);
  useEffect(() => {
    const loadContact = async () => {
      const { data } = await ContactAPI();
      setContactUs(data.data.result);
    };

    if (contactUs === null) {
      loadContact();
    }
  });

  return (
    <div className="hubungi-kami">
      <div className="hubungi-kami-box">
        <div className="hubungi-kami-box__left">
          <div className="hubungi-kami-card">
            <h4>{t("contact_us")}</h4>
            <div className="body">
              <p className="title-place">{t("gedung_bank_kb_bukopin")}</p>
              <p className="title-address">
                {contactUs != null ? contactUs[0].address : ""}
              </p>
              <div className="contact">
                <div className="contact-item">
                  <Phone fill="#fff" className="icon" /> 021 7988 266
                </div>
                <div className="contact-item">
                  <Printer fill="#fff" className="icon" /> 021 7980 625
                </div>
              </div>
            </div>
            <div className="footer d-none">
              <button className="btn btn-primary">{t("next")}</button>
            </div>
          </div>
        </div>
        <div className="hubungi-kami-box__right">
          <div className="hubungi-kami-card">
            <h4>{t("know_us")}</h4>
            <div className="hubungi-kami-box__right-box">
              <div className="hubungi-kami-box__right-box-item">
                <a href="/profile/history" >
                  {t("kb_bukopin_profile")}
                </a>
                <i className="bi bi-chevron-right"></i>
              </div>
              <div className="hubungi-kami-box__right-box-item">
                <a href="/csr-policy" >
                  {t("social_responsibility")}
                </a>
                <i className="bi bi-chevron-right"></i>
              </div>
              <div className="hubungi-kami-box__right-box-item">
                <a href="/structure-corporate/komisaris" >
                  {t("company_management")}
                </a>
                <i className="bi bi-chevron-right"></i>
              </div>
              <div className="hubungi-kami-box__right-box-item">
                <a href="/corporate-governance/about" >
                  {t("company_governance")}
                </a>
                <i className="bi bi-chevron-right"></i>
              </div>
              <div className="hubungi-kami-box__right-box-item borderless-1">
                <a href="/investor">{t("contact_investor")}</a>
                <i className="bi bi-chevron-right"></i>
              </div>
              <div className="hubungi-kami-box__right-box-item borderless-2">
                <a href="/info-terbaru">{t("new_info")}</a>
                <i className="bi bi-chevron-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubungiKami;
